import React from 'react';
import Card from 'react-bootstrap/Card';
import classes from './NavigationLink.css'

const navigationLink = (props) => {

  let cardClasses = 'navigation-link';

  return (
    <Card className={cardClasses} onClick={() => window.open(props.src) } onMouseEnter={() => props.setAccordionKeys([...props.itemIndex].reverse().splice(1).reverse())}>
      <p>{props.name}</p>
    </Card>
  )
};

export default navigationLink
